import platform from "platform";

/**
 * Detects whether the user is accessing the website from an iOS-based device, based
 * on the assumption that only mobile devices has a screen that is higher than
 * it is wide and that the browser is Safari.
 */
export function isIOS(): boolean {
  return (
    platform.os?.family === "iOS" ||
    (platform.name === "Safari" && window.screen.height > window.screen.width)
  );
}
